import { render, staticRenderFns } from "./AppButton.vue?vue&type=template&id=328f29c0&scoped=true&"
import script from "./AppButton.vue?vue&type=script&lang=js&"
export * from "./AppButton.vue?vue&type=script&lang=js&"
import style0 from "./AppButton.vue?vue&type=style&index=0&id=328f29c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328f29c0",
  null
  
)

export default component.exports